<template>
  <div class="p-4">
    <div v-if="customer_state.account_state == 'delinquent'">
      <h4 class="text-danger">{{$t('account_delinquent')}}</h4>
    </div>
    <div v-if="payment_methods">
      <p v-if="payment_methods.length == 0">{{$t('no_payment_method_available')}}</p>
      <div v-else>
        <h4>{{$t('payment_methods')}}</h4>
        <table class="table table-responsive-sm col-8">
          <tbody>
          <tr v-for="payment in payment_methods" :key="payment.id">
            <td v-if="payment.card">{{payment.card.brand|formatCardBrand}} ****{{payment.card.last4}}</td>
            <td v-else-if="payment.sepa_debit">Sepa Debit</td>
            <td v-else>??</td>

            <td v-if="payment.card">{{$t('expires_on')}} {{payment.card.exp_month}}/{{payment.card.exp_year}}</td>
            <td v-else-if="payment.sepa_debit">{{payment.sepa_debit.country}} ****{{payment.sepa_debit.last4}}</td>
            <td v-else></td>

            <td><span v-if="payment.default==true" class="p-2 font-weight-bold">Default</span>
              <button v-else-if="payment.id && payment_methods.length > 1" class="btn btn-sm btn-outline"
                      @click="set_default(payment)"><span class="font-weight-lighter">Set as default</span></button>
            </td>
            <td>

              <button v-if="payment.id && payment_methods.length > 1" class="btn btn-sm btn-danger"
                      v-on:click="will_delete(payment)">
                <span data-feather="x-circle"></span>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-show="stripe">
      <button class="btn btn-outline-primary" v-on:click="show_add_card">{{$t('add_card_to_account')}}</button>
      <button v-if="null" class="btn btn-outline-primary" v-on:click="show_add_sepa">{{$t('add_sepa_to_account')}}</button>

      <div class="col-8 p-0" v-show="visible_add_card">
        <div class="p-0">
          <div id="card-element" class="form-control">
            <!-- A Stripe card Element will be inserted here. -->
          </div>
          <div id="card-errors" role="alert">{{error_message}}</div>
        </div>
        <button class="btn btn-primary btn-sm" v-on:click="submit_add_card">{{$t('add_card')}}</button>
      </div>
      <div class="col-8 p-0" v-show="visible_add_sepa">
          <div class="form-row inline">
            <div class="col">
              <label for="accountholder-name">
                Name
              </label>
              <input
                  id="accountholder-name"
                  name="accountholder-name"
                  v-model = "accountHolderName"
                  placeholder="account name"
                  required
              />
            </div>

            <div class="col">
              <label for="email">
                Email Address
              </label>
              <input
                  id="email"
                  name="email"
                  v-model = "email"
                  type="email"
                  placeholder="email address"
                  required
              />
            </div>
          </div>

        <div class="form-row">
          <label for="iban-element ">
            IBAN
          </label>
          <div id="iban-element">
            <!-- A Stripe Element will be inserted here. -->
          </div>
        </div>


          <!-- Display mandate acceptance text. -->
          <div id="mandate-acceptance">
            By providing your payment information and confirming this payment, you
            authorise (A) Invoxia and Stripe, our payment service provider
            and/or PPRO, its local service provider, to send instructions to your
            bank to debit your account and (B) your bank to debit your account in
            accordance with those instructions. As part of your rights, you are
            entitled to a refund from your bank under the terms and conditions of
            your agreement with your bank. A refund must be claimed within 8 weeks
            starting from the date on which your account was debited. Your rights
            are explained in a statement that you can obtain from your bank. You
            agree to receive notifications for future debits up to 2 days before
            they occur.
          </div>
          <!-- Used to display form errors. -->
           <div class="text-danger">{{error_message}}</div>
        <button class="btn btn-primary btn-sm" v-on:click="submit_add_sepa">{{$t('add_sepa')}}</button>
      </div>

    </div>

    <div class="mt-4">
      <h4>{{$t('invoices')}}</h4>
    </div>
    <div v-if="invoices&&invoices.length||customer_state.upcoming_invoice">
      <table class="table table-responsive-sm table-striped col-8">
        <thead>
        <tr>
          <th class="col-2">{{$t('date')}}</th>
          <th class="col-2">{{$t('amount')}}</th>
          <th class="col-2">{{$t('download')}}</th>
          <th class="col-2"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="customer_state.upcoming_invoice">
          <td>{{customer_state.upcoming_invoice.date|formatDay}}</td>
          <td>{{customer_state.upcoming_invoice.amount}} {{ customer_state.upcoming_invoice.currency}}</td>
          <td></td>
          <td></td>
        </tr>
        <tr v-if='invoices' v-for="invoice in invoices" :key="invoice.id">
          <td>{{invoice.date|formatDay}}</td>
          <td>{{invoice.amount}} {{invoice.currency}}</td>
          <td>
            <a v-if="invoice.link" :href="invoice.link">
              <span data-feather="download"></span>
            </a>
          </td>
          <td>
            <a v-if="!invoice.paid&invoice.hosted_invoice_url" :href="invoice.hosted_invoice_url" target="_blank">
              <span style="fill:red" data-feather="alert-triangle"></span>
              {{$t('pay')}}
            </a>
            <span v-else-if="!invoice.paid" style="fill:red" data-feather="alert-triangle"></span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else-if="invoices">
      <p v-if="invoices.length == 0">{{$t('no_invoice_available')}}</p>
    </div>
    <div v-if="payment_to_delete">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{{$t('delete_payment')}}</h4>
                </div>
                <div class="modal-body">
                  <div>
                    {{$t('delete_payment_condition')}}
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" v-on:click="will_cancel()">
                    {{$t('cancel')}}
                  </button>
                  <button id='delete-btn' class="btn btn-sm btn-danger"
                          v-on:click="on_delete(payment_to_delete)">
                    {{$t('delete')}}
                  </button>
                </div>
              </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style>
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

#iban-element {
  min-width: 300px;
  width: 100%;
}
</style>
<script>

import {HTTP} from "../http-constants";
import "../assets/ith_style.css";
import "../assets/scss/style.scss";
import Vue from "vue";

const feather = require("feather-icons");

Vue.filter('formatCardBrand', value => {
  if (value == 'visa') {
    return "Visa"
  } else if (value == 'mastercard') {
    return "MasterCard"
  } else {
    return value;
  }
});


export default {
  data() {
    return {
      customer_state: {},
      invoices: null,
      payment_methods: null,
      error_message: null,
      card: undefined,
      iban: undefined,
      email: undefined,
      accountHolderName: undefined,
      stripe: null,
      visible_add_card: false,
      visible_add_sepa: false,
      payment_to_delete: null
    };
  },
  methods: {
    show_add_card: function () {
      let new_value = !this.visible_add_card;
      if (new_value) {
        this.visible_add_sepa = false;
      }
      this.visible_add_card = new_value;
    },
    show_add_sepa: function () {
      let new_value = !this.visible_add_sepa;
      if (new_value) {
        this.visible_add_card = false;
      }
      this.visible_add_sepa = new_value;
    },
    will_delete: function (payment_method) {
      this.payment_to_delete = payment_method;
    },
    will_cancel: function () {
      this.payment_to_delete = null;
    },
    on_delete: function (payment_method) {
      let self = this;
      HTTP.delete("/users/payment_methods/" + payment_method.id + "/")
          .then(function (re) {
            let idx = self.payment_methods.indexOf(payment_method);
            if (idx >= 0) {
              self.payment_methods.splice(idx, 1);
            }
            self.payment_to_delete = null;
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    set_default: function (payment_method) {
      let self = this;
      HTTP.patch("/users/payment_methods/" + payment_method.id + "/", {default: true})
          .then(function (re) {
            self.load_payment_methods();
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    load_invoices: function () {
      let self = this;
      HTTP.get("/users/invoices/")
          .then(function (re) {
            self.invoices = re.data;
          })
          .catch(function (error) {
            self.invoices = []
            console.log(error);
          });
    },
    load_user_state: function () {
      let self = this;
      HTTP.get("/users/payment_state/")
          .then(function (re) {
            self.customer_state = re.data;
            let public_key = self.customer_state.public_key
            self.stripe_prepare(public_key);
          })
          .catch(function (error) {
            self.customer_state = {}
            console.log(error);
          });
    },
    load_payment_methods: function () {
      let self = this;
      HTTP.get("/users/payment_methods/")
          .then(function (re) {
            self.payment_methods = re.data;
          })
          .catch(function (error) {
            self.payment_methods = []
            console.log(error);
          });
    },
    stripe_prepare: function (public_key) {
      this.stripe = Stripe(public_key);
      let elements = this.stripe.elements();

      let style = {
        base: {
          fontSize: "16px",
          color: "#32325d",
          fontFamily:
              "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
          fontSmoothing: "antialiased",
          "::placeholder": {
            color: "rgba(0,0,0,0.4)"
          }
        }
      };

      this.card = elements.create("card", {style: style});
      this.card.mount("#card-element");

      let sepa_style = {
        base: {
          color: '#32325d',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          },
          ':-webkit-autofill': {
            color: '#32325d',
          },
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a',
          ':-webkit-autofill': {
            color: '#fa755a',
          },
        },
      };
      var options = {
        style: sepa_style,
        supportedCountries: ['SEPA'],
        placeholderCountry: 'FR',
      };

      this.iban = elements.create('iban', options);
      this.iban.mount('#iban-element');
    },
    submit_add_card: function () {
      let self = this;
      let intent_secret = self.customer_state.intent_secret;

      self.error_message = "";
      self.stripe.confirmCardSetup(intent_secret, {
        payment_method: {
          card: self.card,
        }
      })
          .then(function (result) {
            if (result.error) {
              self.error_message = result.error.message;
            } else {
              //success reload card
              self.load_payment_methods();
              self.card.clear();
              self.visible_add_card = false;
            }
          });
    },
    submit_add_sepa: function () {
      let self = this;
      let intent_secret = self.customer_state.intent_secret;

      self.error_message = "";
      self.stripe.confirmSepaDebitSetup(intent_secret, {
        payment_method: {
          sepa_debit: self.iban,
          billing_details: {
            name: self.accountHolderName,
            email: self.email
          }
        }
      })
          .then(function (result) {
            if (result.error) {
              self.error_message = result.error.message;
            } else {
              //success reload card
              self.load_payment_methods();
              self.iban.clear();
              self.visible_add_sepa = false;
            }
          });
    },
    orderComplete: function (clientSecret) {
      this.stripe.retrieveSetupIntent(clientSecret).then(function (result) {
        let setupIntent = result.setupIntent;
        let setupIntentJson = JSON.stringify(setupIntent, null, 2);

      });
    }
  },
  mounted() {
    this.load_invoices();
    this.load_payment_methods();
    this.load_user_state();

  },
  updated() {
    feather.replace();
  }
};
</script>
